/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_BroochInputs */

const en_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brooch`)
};

const es_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broche`)
};

const fr_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broche`)
};

const de_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brosche`)
};

const ja_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブローチ`)
};

const zh_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`胸针`)
};

const ar_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بروش`)
};

const id_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bros`)
};

const it_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spilla`)
};

const ru_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Брошь`)
};

const pt_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broche`)
};

const ko_val_brooch = /** @type {(inputs: Val_BroochInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브로치`)
};

/**
* | output |
* | --- |
* | "Brooch" |
*
* @param {Val_BroochInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_brooch = /** @type {((inputs?: Val_BroochInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_BroochInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_brooch(inputs)
	if (locale === "es") return es_val_brooch(inputs)
	if (locale === "fr") return fr_val_brooch(inputs)
	if (locale === "de") return de_val_brooch(inputs)
	if (locale === "ja") return ja_val_brooch(inputs)
	if (locale === "zh") return zh_val_brooch(inputs)
	if (locale === "ar") return ar_val_brooch(inputs)
	if (locale === "id") return id_val_brooch(inputs)
	if (locale === "it") return it_val_brooch(inputs)
	if (locale === "ru") return ru_val_brooch(inputs)
	if (locale === "pt") return pt_val_brooch(inputs)
	return ko_val_brooch(inputs)
});